<template>
    <v-tooltip :top="isTop" :right="isRight" :left="isLeft" :bottom="isBottom">
        <template v-slot:activator="{ on }">
            <v-btn
                v-if="isCanUnlock"
                :disabled="isDisabled || isLoading"
                :loading="isLoading"
                icon
                small
                class="mr-0 ml-0"
                v-on="on"
                @click="$emit('click')"
            >
                <v-icon color="warning" small> lock </v-icon>
            </v-btn>
            <v-icon v-else color="warning" class="icon-padding-unified" small v-on="on"> lock </v-icon>
        </template>
        <span class="button-label">{{ $t('Locked') }}</span>
    </v-tooltip>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'ButtonIconLocking',
})
export default class ButtonIconLocking extends Vue {
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) canUnlock: boolean;
    @Prop({ default: false }) top: boolean;
    @Prop({ default: false }) right: boolean;
    @Prop({ default: false }) left: boolean;
    @Prop({ default: false }) bottom: boolean;

    get isDisabled(): boolean {
        return this.disabled;
    }
    get isLoading(): boolean {
        return this.loading;
    }
    get isCanUnlock(): boolean {
        return this.canUnlock;
    }
    get isTop(): boolean {
        return this.top;
    }
    get isRight(): boolean {
        return this.right;
    }
    get isLeft(): boolean {
        return this.left;
    }
    get isBottom(): boolean {
        return this.bottom;
    }
}
</script>

<style lang="scss" scoped>
.button-label {
    font-weight: bolder;
}
</style>
